/*
All the Url Mappings for our Application
 */

let contextPath = '/my';

const UrlMappings = {
	HOME: contextPath + '/',
    ACTIVATE: "/activate/spa/:uuid",
    ACTIVATE_THANK_YOU: "/activate/thankyou",
    ACTIVATE_PWR: "/activate/complete/:uuid/:pwrUuid",
	ALBUMS: contextPath + '/albums',
    ALBUM_BASE: `/my/album/`,
	ALBUM: `/my/album/:id`,
    ALBUM_SELECT: `/my/album/:id/select`,
	ALBUMS_SELECT: `${contextPath}/albums/select`,
	CART: contextPath + '/cart',
	SHOP: contextPath + '/shop',
    CART_CHECKOUT: contextPath + '/cart/checkout',
    CART_SUMMARY: contextPath + '/cart/checkout/summary',
	DISCS: contextPath + '/discs',
	DOWNLOADS: contextPath + '/downloads',
	MY_ACCOUNT: contextPath + '/account',
	ORDER_HISTORY: contextPath + '/orders',
	PAYMENT_ACCOUNTS: contextPath + '/payment-accounts',
	PROFILE: contextPath + '/profile',
	REFERRAL_REWARDS: contextPath + '/referral-rewards',
	SHARES: contextPath + '/shares',
	SUBSCRIPTION: contextPath + '/account/storage-plan',
	TIMELINE: contextPath + '/timeline',
	TRANSFER_MEDIA: contextPath + '/transfer-media',
	TRASH: contextPath + '/restore-media',
	USB: contextPath + '/usb-wizard',
	UPLOAD: contextPath + '/upload',
    SIGNUP: contextPath + '/signup'
};

export const getBrandName = searchString => {
	let queryStringProps = searchString.replace('?', '').split('=');

	for (let i = 0; i < queryStringProps.length; i++) {
		if (queryStringProps[i].toLowerCase() === 'brandname') return queryStringProps[i + 1];
	}

	return 'base';
};

export const getBrandPath = brandName => {
	return `${process.env.REACT_APP_BRAND_BASE_URL}/web-resources/v3/${brandName}`;
};

export const getBrandCssPath = brandName => {
	return `${getBrandPath(brandName)}/css/brand.css`;
};

export const getQueryParam = name => {
	const regex = "[?|&]" + name + "=([^&;]+?)(&|#|;|$)";
    return (new RegExp(regex).exec(decodeURIComponent(window.location.search))||["",""])[1].replace(/\+/g, '%20')||null;

};

export default UrlMappings;



// WEBPACK FOOTER //
// ./src/common/url-mappings.js